import React from "react";
import { FaFileContract, FaShieldAlt, FaHeadset, FaGlobeEurope } from "react-icons/fa";

const items = [
  {
    icon: FaFileContract,
    title: "Propozime të qarta",
    text: "Fushëveprim, pika kufitare dhe vlerësime me shkrim para fillimit të punës.",
  },
  {
    icon: FaShieldAlt,
    title: "Dorëzim me fokus në siguri",
    text: "Rrjedha të sigurta, NDA opsionale dhe trajtim i kujdesshëm i të dhënave tuaja.",
  },
  {
    icon: FaHeadset,
    title: "Partneritet i vazhdueshëm",
    text: "Kalim i strukturuar, dokumentacion dhe opsione mbështetjeje pas lançimit.",
  },
  {
    icon: FaGlobeEurope,
    title: "Remote, me standarde europiane",
    text: "Punojmë online me klientë kudo — me komunikim të rregullt dhe orare të koordinuara.",
  },
];

function TrustBar() {
  return (
    <section className="trust-bar" aria-label="Pse na zgjedhin ekipet">
      <div className="container trust-bar-inner">
        {items.map(({ icon: Icon, title, text }) => (
          <div key={title} className="trust-bar-item">
            <span className="trust-bar-icon" aria-hidden="true">
              <Icon />
            </span>
            <div>
              <h3 className="trust-bar-title">{title}</h3>
              <p className="trust-bar-text">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TrustBar;
